import { IPessoaFisica } from "@/interfaces/persona.interface";
import { api } from "@/lib/api/axios";
import {
  ConfiguracoesPFFormData,
  ConfiguracoesPJFormData,
  PerfilFormData,
  AlterarSenhaFormData,
  PermissionsFormData,
} from "@/pages/configuracoes/schemas";

const CONFIGURACOES_API_PATH = "/configuracoes";

export const configuracoesService = {
  getConfiguracoesPF: async () => {
    const response = await api.get<IPessoaFisica>(`${CONFIGURACOES_API_PATH}/pessoa-fisica`);

    if (response.birthDate && typeof response.birthDate === 'string') {
      response.birthDate = new Date(response.birthDate);
    }

    return response;
  },

  updateConfiguracoesPF: async (data: ConfiguracoesPFFormData) => {
    const response = await api.patch(`${CONFIGURACOES_API_PATH}/pessoa-fisica`, data);
    return response;
  },

  getConfiguracoesPJ: async () => {
    const response = await api.get(`${CONFIGURACOES_API_PATH}/pessoa-juridica`);
    // Ensure we always return an object, never undefined
    return response || {};
  },

  updateConfiguracoesPJ: async (data: ConfiguracoesPJFormData) => {
    const response = await api.patch(`${CONFIGURACOES_API_PATH}/pessoa-juridica`, { ...data, is_juridic: true });
    return response;
  },

  uploadDocument: async (fieldName: string, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fieldName', fieldName);
    const response = await api.post(`${CONFIGURACOES_API_PATH}/documentos`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  },

  getDocuments: async () => {
    const response = await api.get(`${CONFIGURACOES_API_PATH}/documentos`);
    return response || {};
  },

  // Perfil endpoints
  getPerfil: async () => {
    const response = await api.get<IPessoaFisica>(`${CONFIGURACOES_API_PATH}/perfil`);
    return response;
  },

  updatePerfil: async (data: PerfilFormData) => {
    const response = await api.patch(`${CONFIGURACOES_API_PATH}/perfil`, data);
    return response;
  },

  uploadProfileImage: async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(`${CONFIGURACOES_API_PATH}/perfil/image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  },

  // Password change endpoint
  changePassword: async (data: AlterarSenhaFormData) => {
    const response = await api.post('/auth/change-password', data);
    return response;
  },

  // Permissions endpoints
  getPermissions: async () => {
    const response = await api.get<{ message: string; permissions: any }>(`${CONFIGURACOES_API_PATH}/permissions`);
    // Backend returns { message, permissions }, extract just permissions
    return response.permissions || {};
  },

  updatePermissions: async (data: PermissionsFormData) => {
    const response = await api.patch(`${CONFIGURACOES_API_PATH}/permissions`, data);
    return response;
  },
};
